import React from 'react'
import Map, { Marker } from 'react-map-gl/mapbox'
import 'mapbox-gl/dist/mapbox-gl.css'
import { useTheme } from '@react-navigation/native'
import Config from '@config'
import { instagramMapStyle } from '../../menu/map/mapStyle'

const MAP_STYLE = JSON.parse(instagramMapStyle)
const ZOOM = 15

interface VenueMapProps {
  latitude: number
  longitude: number
  height?: number
  /** Rounded border around the map (off when the parent already draws a frame). */
  framed?: boolean
}

/** Static (non interactive) map preview with one marker on the venue. */
export function VenueMap({ latitude, longitude, height = 180, framed = true }: VenueMapProps) {
  const theme = useTheme()
  return (
    <div
      data-testid="venue-map"
      style={{
        height,
        overflow: 'hidden',
        ...(framed
          ? { borderRadius: theme.border.large, border: `1px solid ${theme.colors.grey}` }
          : {}),
      }}
    >
      <Map
        // Re-centre when another venue is picked (the map itself is not interactive).
        key={`${latitude},${longitude}`}
        initialViewState={{ latitude, longitude, zoom: ZOOM }}
        mapboxAccessToken={Config.MAPBOX_ACCESS_TOKEN}
        mapStyle={MAP_STYLE}
        interactive={false}
        style={{ width: '100%', height: '100%' }}
      >
        <Marker latitude={latitude} longitude={longitude} anchor="center">
          <div
            style={{
              width: theme.iconSize.medium,
              height: theme.iconSize.medium,
              borderRadius: '50%',
              backgroundColor: theme.colors.primary,
              border: `3px solid ${theme.colors.white}`,
              boxShadow: `0 0 0 1px ${theme.colors.primary}`,
            }}
          />
        </Marker>
      </Map>
    </div>
  )
}
